var React = require('react');

function MenuClosed (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"19","height":"2","rx":"0.952381","transform":"matrix(-1 0 0 1 23.332 10)","key":0}),React.createElement("rect",{"width":"19","height":"2","rx":"0.952381","transform":"matrix(-1 0 0 1 23.334 16)","key":1})]);
}

MenuClosed.defaultProps = {"width":"28","height":"28","viewBox":"0 0 28 28"};

module.exports = MenuClosed;

MenuClosed.default = MenuClosed;
